"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _HashManager = _interopRequireDefault(require("../../components/common/HashManager"));

var _Title = _interopRequireDefault(require("../../components/media/models/Title"));

var _TitleActions = _interopRequireDefault(require("../../title-actions/TitleActions"));

var _forwardedActions = require("../forwardedActions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ProcessForwardedAction =
/*#__PURE__*/
function () {
  function ProcessForwardedAction(collection, bus, model) {
    _classCallCheck(this, ProcessForwardedAction);

    var hash = _HashManager["default"].get('action')[0];

    this.actionArr = hash ? hash.split('~') : [];
    this.action = this.actionArr[0] || null;
    this.mediaId = this.actionArr[1] || null;
    this.rating = this.actionArr[2] || 0;
    this.model = model || null;
    this.collection = collection.models;
    this.bus = bus;
  } // Execute user forwarded action


  _createClass(ProcessForwardedAction, [{
    key: "executeAction",
    value: function executeAction() {
      var _this = this;

      if (!this.action || !this.mediaId) {
        return;
      }

      if (!this.model || this.model && this.model.get('id') !== this.mediaId) {
        this.model = _.find(this.collection, function (model) {
          return model.id === _this.mediaId;
        });
      }

      var titleActions = new _TitleActions["default"]({
        bus: this.bus
      });

      if (this.model) {
        // Title model is on page
        _HashManager["default"].remove('action'); // LHTNG-1685 - Throw conflict modal if title is isOwned on a 'recommend' forwarded action


        if (this.action === 'recommend' && this.model.get('isOwned')) {
          if (this.model.get('titleState') === 'borrow') {
            this.bus.trigger('title:hold:conflict', {
              titleModel: this.model
            });
          } else {
            this.bus.trigger('title:borrow:conflict', {
              titleModel: this.model
            });
          }

          return;
        }

        this.model.set('userStarRating', this.rating);
        titleActions.perform(this.action, this.model);
      } else if (this.action === 'recommend' && $("a.primary-action[data-media-id=\"".concat(this.mediaId, "\"]")).length > 0) {
        // Recommended from the preview row
        // Remove after RTL preview row is refactored
        (0, _forwardedActions.recommend)('', this.action, this.bus);

        _HashManager["default"].remove('action');
      } else {
        // Title model is not on page, fetch async
        var title = new _Title["default"]();
        var promise = new Promise(function (resolve, reject) {
          title.getTitleAsync(_this.mediaId, resolve, reject);
        });
        promise.then(function () {
          _this.model && _this.model.set('userStarRating', _this.rating);
          titleActions.perform(_this.action, title);

          _HashManager["default"].remove('action');
        });
      }
    }
  }]);

  return ProcessForwardedAction;
}();

exports["default"] = ProcessForwardedAction;